/**
 * Created by yniran on 12/13/14.
 */

/*
 CHAT API DOCS: https://connect.liveperson.com/docs/DOC-2292
 */

define(function (require) {
    "use strict";

    var LE = require("app"),
        CONST = require("const"),
        CP_CONST = require("connection-const"),
        AuthenticationModel = require("connection-models/chatTab/AuthenticationModel"),
        ChatApiController = {};

    var WAIT_TIME = CP_CONST.CHAT_RECONNECT.WAIT_TIME; // we wait 5 seconds
    var RETRY_COUNT = CP_CONST.CHAT_RECONNECT.RETRY_COUNT;

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;
        var authConnectorTypes = {
                "S2S": 0,
                "OAUTH_IMPLICIT": 1,
                "OAUTH_CODE": 2
        };

        ChatApiController = Marionette.Controller.extend({
            sessionWorkaroundValue: Math.floor((Math.random() * 1000) + 1), //TODO delete

            initialize: function (options) {
                logger.debug("initialize : entered", "ChatApiController.initialize");
                this._stateModel = options.stateModel;
                this._connectionPanelContextModel = options.contextModel;
                this._chatStates = CP_CONST.CHAT_STATES;
                this._chatChannel = options.chatChannel;
                this._connectionInitialized = false;
                this._chatAPI = null;
                this._chatInitiatedBy = null;
                this._queuedChatRequest = null;
                this._chatRequestIssuing = false; //true while request is issued but no response yet
                this._chattingInProgress = false;
                this._chatEnded = false;
                this._retryCount = 0;
                this._blockErrors = false;
                this._bindEvents();
            },

            _bindEvents: function () {   //exposes the controller's API through event and request handlers

                var cVent = this._chatChannel.vent;

                this.listenTo(cVent, "chatConnection:initialize:request", this._initChatConnection);
                this.listenTo(cVent, "chat:start:request", this._handleChatStartRequest);
                this.listenTo(cVent, "messaging:reconnect", this._handleMessagingReconnect);
                this.listenTo(cVent, "chat:sendLine:update", this._handleSendLineUpdate);
                this.listenTo(cVent, "chat:userTyping:update", this._handleUserTypingUpdate);
                this.listenTo(cVent, "chat:close:request", this._handleChatCloseRequest);
                this.listenTo(cVent, "chatConnection:surveySubmit:request", this._handleSurveySubmitRequest);
                this.listenTo(cVent, "chatStartData:info:ready", this._onChatInformationRetrieved);
                this.listenTo(cVent, "chat:getOfflineSurvey", this._checkChatOfflineSurvey);
                this.listenTo(cVent, "chat::logout", this._onLogout);
                this.listenTo(cVent, "contacts:getAvailability", this._getAvailability);
                this.listenTo(this._connectionPanelContextModel, "change:chatMode", this._onChatModeChanged);
                this.listenTo(LE.vent,'LPTagConfigModel:config:changed', this._onMtagModelChanged);


                var cReqRes = this._chatChannel.reqres;

                cReqRes.setHandler("chatInfo::request:chatState", this._getCurrentState, this);
                cReqRes.setHandler("chatInfo::request:isChatting", this._getIsChatting, this);
                cReqRes.setHandler("chatInfo::request:isChatEnded", this._getIsChatEnded, this);
            },

            _onMtagConfigReady: function () {
                lpTag.events.bind("LP_OFFERS", "START", this._onEngagementRetrieved);
                LEConnection.vent.trigger("tryPushingSDEs");
            },

            _onChatModeChanged: function(){
                if(this._getCurrentState() === this._chatStates.CHATTING){
                    setTimeout(this._onChatModeChanged.bind(this), 5000);
                }else{
                    this._isSwitchChatAPI = true;
                    this._onChatApiReady();
                }
            },

            _onMtagModelChanged: function (){
                LEConnection.vent.trigger("tryPushingSDEs");
                this._chatChannel.vent.trigger("chatConnection:chat:close");
                this._chatChannel.vent.trigger("remove:messaging:frames");
                this._connectionPanelContextModel.resetMessagingContacts();
            },

            _onChatApiReady: function () {

                if (lpTag && lpTag.taglets.ChatOverRestAPI) {

                    this._chatChannel.vent.trigger("chatAPI:ready");

                    this._chatStates = lpTag.taglets.ChatOverRestAPI.prototype.chatStates;

                    lpTag.events.bind('LPTAG', 'ON_STARTED', (function(){
                        var chatDomain = this._getChatDomain();
                        var chatOptions = {
                            site: this._connectionPanelContextModel.getSupportSiteId(),
                            domain:  chatDomain,
                            appKey: this._connectionPanelContextModel.getSupportAccountAppKey(),
                            sessionUID: (LE.context.get("persona") !== CONST.PERSONA.GUEST ? LE.sessionManager.getGlob() : "")
                        };

                        this._chatAPI = this._createChatApiObject(chatOptions);
                    }).bind(this));
                }
                else {
                    logger.error("failed to find the chat over rest api", "ChatApiController");
                    logger.graph({name:"connection:ChatApiController:_onChatApiReady:missingChatOverRestAPI"});
                }
            },

            _getChatDomain: function () {
                var chatDomain = null;
                if (lpTag && lpTag.csds) {
                    chatDomain = lpTag.csds.getDomain('adminArea');
                }
                if (this._isSwitchChatAPI) {
                    chatDomain = LE.urlResolver.getConfigValue('monitoredAccountServer');
                }
                return chatDomain;
            },

            _onEngagementRetrieved: function(engagement){
                logger.debug("engagement retrieved");
                LEConnection.vent.trigger("chatContacts:engagements:retrieved", engagement);
            },

            //***************************************************************
            //CONTROLLER API METHODS

            _initChatConnection: function () {
                LEConnection.vent.trigger("chatApi::init:chatConnection");
                this.listenTo(LE.vent, "LPtag_mtaconfig:loaded", this._onMtagConfigReady);
            },

            _handleSurveySubmitRequest: function (options) {

                var callback = options.callback;

                logger.info("about to submit survey", "ChatApiController._onSurveySubmitRequest", options.survey);

                if (this._chatAPI) {

                    var submitMethod = null;

                    switch (options.surveyType) {
                        case CP_CONST.SURVEY_TYPES.OFFLINE:
                            submitMethod = this._chatAPI.submitOfflineSurvey;
                            break;
                        case CP_CONST.SURVEY_TYPES.EXIT:
                            submitMethod = this._chatAPI.submitExitSurvey;
                            break;
                    }

                    if (submitMethod) {
                        try {
                            submitMethod.call(this._chatAPI, {
                                survey: options.survey,
                                success: _.bind(this._onSurveySubmitResponse, this, callback),
                                error: _.bind(this._onSurveySubmitResponse, this, callback)
                            });
                        }
                        catch (ex) {
                            logger.error("encountered error while trying to submit survey", "ChatApiController._onSurveySubmitRequest", ex);
                            logger.graph({name:"connection:ChatApiController:_handleSurveySubmitRequest:exception"});
                            callback({result: false, error: true, message: "LEConnection.survey.unexpectedError"});
                        }
                    }
                    else {
                        logger.warn("received survey type to submit that cannot be handled!: " + options.surveyType, "ChatApiController._onSurveySubmitRequest");
                    }
                }
                else {
                    callback({result: false, error: true, message: "LEConnection.survey.unexpectedError"});
                }
            },

            _handleChatCloseRequest: function () {

                logger.debug("received request to close chat", "ChatApiController._handleChatCloseRequest");
                this._endChat();
            },

            _handleChatStartRequest: function (options) {
                logger.debug("received request to start chat", "ChatApiController._handleChatStartRequest");
                options = _.extend({initSource: CP_CONST.CHAT_INITIATED_SOURCE.USER}, options);
                this._handleChatRequestWithChatInitialized(options);

            },

            _handleSendLineUpdate: function (userLine) {

                logger.debug("received update to send chat line", "ChatApiController._handleSendLineUpdate", userLine);

                if (this._getIsChatting()) {

                    var text = _.isArray(userLine.text) ? userLine.text : [userLine.text];

                    _.each(text, function (lineText) { //need to send each text part as its own line, chat api doesnt support multiple lines in a single message
                        this._chatAPI.addLine({
                            source: userLine.source,
                            text: lineText,
                            textType: userLine.textType
                        });
                    }, this);
                }
            },

            _handleUserTypingUpdate: function (data) {
                logger.debug("received update to send typing status: " + data.typing, "ChatApiController._handleUserTypingUpdate");

                if (this._getIsChatting()) {
                    this._chatAPI.setVisitorTyping(data);
                }
            },

            _getIsChatting: function () {

                var currentState = this._getCurrentState();

                return (currentState && currentState === this._chatStates.CHATTING);
            },

            _getIsChatEnded: function () {

                var currentState = this._getCurrentState();

                return (currentState && currentState === this._chatStates.ENDED);
            },

            _getSessionInfo: function(){
              return {
                  chatId: this._chatAPI.getRtSessionId(),
                  agentId: this._chatAPI.getAgentId(),
                  visitorName: this._chatAPI.getVisitorName()
              };
            },

            _getAvailability: function(options){
                if (this._chatAPI) {
                    this._chatAPI.getAvailabilty({
                        skill: options.skill,
                        success: options.success,
                        error: options.error,
                        context: this
                    });
                }
            },

            //CONTROLLER API METHODS - END
            //***************************************************************

            //***************************************************************
            //CHAT METHODS

            _handleChatRequestWithChatInitialized: function (options) {
                logger.debug("about to start chat !!!!!", "ChatApiController._handleChatRequestWithChatInitialized", options);
                var model = options.model;

                if (lpTag.taglets.lp_monitoringSDK) {
                    if (model) {
                        this._reportChatRequestUsage(model);
                        if (model.isMessagingContact()){
                            this._startMessaging(model);
                        } else {
                            this._startChatting(options);
                        }
                    } else {
                        logger.error("no model to start a conversation");
                    }
                } else {
                    logger.error("lpTag.taglets.lp_monitoringSDK not loaded");
                }
            },

            _handleMessagingReconnect: function (options) {
                var chatState, isCPOpen, isMessagingConversationDisplayed;
                if (options.isMessagingConversationLoaded) {
                    chatState = this._stateModel.getState();
                    isCPOpen = this._connectionPanelContextModel.get("isOpen");
                    isMessagingConversationDisplayed = isCPOpen &&
                        chatState.chatTab === CP_CONST.CHAT_TAB_STATES.CHAT_WINDOW &&
                        chatState.iframe === CP_CONST.CONVERSATION_IFRAME_STATE.MESSAGING;
                    if (isMessagingConversationDisplayed) {
                        var callback = _.bind(this._initUnifiedWindow, this, options.model);
                        LE.lpGetAuthentication(callback, options.model);
                    } else {
                        if (!isCPOpen) {
                            this._triggerEvent("chatConnection:chat:close");
                        }
                        options.isMessagingConversationLoaded = false;
                    }
                }
            },

            _startMessaging: function (model) {
                var timeout;
                this._triggerEvent("cpChatUI:display:messagingFrame", model);
                if (model.isMessagingConversationLoaded) {
                    timeout = 0;
                } else {
                    model.isMessagingConversationLoaded = true;
                    var callback = _.bind(this._initUnifiedWindow, this, model);
                    LE.lpGetAuthentication(callback, model);
                    timeout = 1000;
                }
                setTimeout(this._triggerShowConversationView.bind(this), timeout);
            },

            _startChatting: function (options) {
                var currenChatState, isNoOngoingChat;
                currenChatState = this._getCurrentState();
                isNoOngoingChat = currenChatState !== this._chatStates.WAITING && currenChatState !== this._chatStates.CHATTING;

                if (isNoOngoingChat) {
                    this._chatInitiatedBy = options.initSource;
                    this._queuedChatRequest = {
                        time: new Date(),
                        referrerAction: options.referrerAction
                    }; //overrides the previous queued
                    this._chatChannel.commands.execute("chatStartData:request:createChatInformation", {contactModel: options.model});
                    this._triggerEvent("click:chatGroup", options.model.get("displayName"));
                    this._triggerEvent("cpChatUI:display:chatFrame", options.model.getSkillName(), this._getCurrentState());
                }else{
                    this._triggerEvent("cpChatUI:display:chatFrame", options.model.getSkillName(), this._getCurrentState());
                    this._triggerShowConversationView();
                }
            },

            _initUnifiedWindow: function (model, token) {
                var unifiedWindowCfg = this._createEncodedUnifiedWindowConfig(model, token);
                if (model.isMessagingContact()) {
                    this._triggerEvent("load:unifiedWindowInMessagingFrame", {contactModel: model, unifiedWindowCfg: unifiedWindowCfg});
                } /*else {
                    this._triggerEvent("load:unifiedWindowInChatFrame", unifiedWindowCfg);
                }*/
            },

            /*_isEqualToLastChatEngagement: function (model) {
                if (this.lastChatEngagement) {
                    var sameEngagement = model.getEngagementId() === this.lastChatEngagement.get("engagementId");
                    var sameCampaign = model.getCampaignId() === this.lastChatEngagement.get("campaignId");
                    return sameCampaign && sameEngagement;
                } else {
                    return false;
                }
            },*/

            _createEncodedUnifiedWindowConfig: function (model, token) {
                var config = {
                    "accountId": LE.LPtag_mtaconfig.siteId,
                    "env": LE.LPtag_mtaconfig.unifiedWindow.environment,
                    "external": true,
                    "chatSessionTimeout": {"desktop": 20, "mobile": 20, "tablet": 30},
                    "supportBlockCCPattern": true,
                    "secureStorageType": "indexDB",
                    "hide_lp_logo": false,
                    "hideTopBar": true
                    // "lpVersion": LEConfig.connectionPanelSettings.unifiedWindow.version
                };

                config.engConf = this._createEngagementConfig(model, token);
                return this._encodeConfig(config);
            },

            _encodeConfig: function (configObject) {
                var configString, encodedConfig;

                configString = JSON.stringify(configObject);
                encodedConfig = encodeURIComponent(configString);

                return encodedConfig;
            },

            _createEngagementConfig: function (model, token) {
                //a messaging conversation is requested iff the token is set
                var config,
                    authConnId,
                    monitoringSDK,
                    cpSettings,
                    workaround;
                cpSettings = LE.LPtag_mtaconfig.unifiedWindow;
                monitoringSDK = lpTag.taglets.lp_monitoringSDK;

                workaround = monitoringSDK.getSid();
                // if (window.useWorkaround) {
                    workaround += this.sessionWorkaroundValue++; //workaround to "reset" the session storage for every engagement
                // }

                config = {
                    "async": !!token,
                    "scid": model.getContextId(),
                    "cid": model.getCampaignId(),
                    "eid": model.getEngagementId(),
                    "lang": this._connectionPanelContextModel.get("locale") || 'en-US',
                    "svid": monitoringSDK.getVid(),
                    "ssid": workaround,
                    "skill": model.getAvailability() ? model.getSkillName() : model.getBackupSkillName(),
                    "lewid": cpSettings.windowId
                };

                if (token) {
                    config.ssoKey = token;
                    config.connector = this._retrieveConnector(cpSettings.authenticationType);
                }
                return config;
            },

            _retrieveConnector: function(type){
                  var connector =  {};
                  connector.type = authConnectorTypes[type] || authConnectorTypes.OAUTH_IMPLICIT;
                  return connector;
            },

            _triggerShowConversationView: function () {
                this._triggerEvent("cpChatUI::layout:chat:show", {
                    initSource: this._chatInitiatedBy,
                    state: this._getCurrentState(),
                    states: this._chatStates
                });
            },

            _onChatInformationRetrieved: function (chatInfo) {

                logger.debug("retrieved chat information", "ChatApiController._onChatInformationRetrieved");

                if (this._queuedChatRequest) {
                    logger.debug("about to issue queued chat request: ", "ChatApiController._onChatInformationRetrieved", this._queuedChatRequest);
                    this._issueChatRequest(chatInfo, this._queuedChatRequest);
                    this._queuedChatRequest = null;
                }
            },

            _issueChatRequest: function (chatInfo, queuedRequest) {

                if (!this._getIsChatting()) {
                    if (this._chatAPI) {

                        var chatReq = this._getChatRequestInfo(chatInfo);

                        logger.debug("issuing chat request, got all the information needed", "ChatApiController._issueChatRequest", chatInfo);

                        if (chatReq.skill) {     //currently only requesting availability for skill to determine whether to show offline survey or not
                            this._issueChatRequestForSkill(chatReq);
                        }
                        else {
                            this._sendApiChatRequest(chatReq);
                        }
                    }
                    else {
                        logger.error("chat api object is unavailable  - cant issue request", "ChatApiController._issueChatRequest");
                        logger.graph({name: "connection:ChatApiController:_issueChatRequest:chatAPiObjMissing"});
                    }
                }
                else {
                    logger.warn("received request to start chat while chat in progress !!!!", "ChatApiController._issueChatRequest");
                }
            },
            //[31/3.15 Ela A.] As for now, the chats requests are reported by the monitoring site, and not by us. Ella B. asked to remove this usage report.
            _reportChatRequestUsage: function (model) {

               var usageTarget = CP_CONST.USAGE_TO_TRACK.CHAT.CLICK_TO_CHAT_GROUP;
               var usageId = model.getSkillName();

               var referrerAction = CP_CONST.REFERER_ACTION.USER;

               LEConnection.vent.trigger("UsageTrackingController:track", {usageToTrack: usageTarget, slug: usageId, referrerAction: referrerAction});
            },

            _issueChatRequestForSkill: function (chatReq) {

                var onAvailabilityResponse = function (data) {
                    this._onChatRequestAvailabilityResponse(data, chatReq);   //'this' is passed by the call
                };

                this._chatAPI.getAvailabilty({
                    skill: chatReq.skill,
                    success: onAvailabilityResponse,
                    error: onAvailabilityResponse,
                    context: this
                });
            },

            _sendApiChatRequest: function (chatReq) {

                if (!this._chatRequestIssuing) {
                    logger.debug("requesting chat", "ChatApiController._sendApiChatRequest", chatReq);

                    this._chatRequestIssuing = true;
                    _.extend(chatReq, {
                        siteContainer: window.lpMTagConfig.FPC_CONT, //for supporting federated sites
                        success: this._onChatRequestResponse,
                        error: this._onChatRequestResponse,
                        context: this
                    });
                    chatReq.language = this._connectionPanelContextModel.get("locale") || "en-US";
                    if(this._isSwitchChatAPI){
                        this._triggerEvent("chatConnection:exitSurvey:info");
                        this._isSwitchChatAPI = false;
                    }
                    this._chatAPI.requestChat(chatReq);  //request chat session from the API
                }
                else {
                    logger.debug("not issuing another chat request while one is pending", "ChatApiController._sendApiChatRequest");
                }
            },

            _getChatRequestInfo: function (info) {

                var chatReq = {   //take only the information LP needs to start API chat
                    referrer: info.referrer,
                    visitorSessionId: info.visitorSessionId,
                    agent: info.agent,
                    skill: info.skill,
                    backupSkill: info.backupSkill,
                    ssoKey: info.ssoKey,
                    ssoServiceKey: info.ssoServiceKey,
                    ssoServiceExtraParams: info.ssoServiceExtraParams
                };

                if (info.visitorSessionId !== -1) { //use the visitor session id if its a valid one
                    chatReq.visitorSessionId = info.visitorSessionId;
                }

                return chatReq;
            },

            //CHAT METHODS - END
            //***************************************************************

            //***************************************************************
            //SURVEY METHODS

            _onOfflineSurveyResponse: function (data) {

                logger.debug("received offline survey data", "ChatApiController._onOfflineSurveyResponse", data);

                this._leaveChatApiFrame(function () {
                    if (!data.error && data.survey && data.survey.id && data.survey.questions) {
                        this._triggerEvent("chatConnection:survey:show", {surveyInfo: data.survey, surveyType: CP_CONST.SURVEY_TYPES.OFFLINE});
                    } else {// no offline survey - We seek to be responsive user click
                        LEConnection.notifier.showError(LE.translator.translate("LEConnection.chat.livePersonChatWidgetContactUnavailable"));
                    }
                });
            },

            _onExitSurveyResponse: function (data) {

                logger.debug("received exit survey data", "ChatApiController._onExitSurveyResponse", data);

                this._leaveChatApiFrame(function () {
                    if (!data.error && data.survey && data.survey.id) {
                        this._triggerEvent("chatConnection:survey:show", {surveyInfo: data.survey, surveyType: CP_CONST.SURVEY_TYPES.EXIT});
                        this._triggerEvent("chatConnection:exitSurvey:info", {retrieved: true});
                    }

                    this._triggerEvent("chatConnection:exitSurvey:info", {retrieved: false});
                });
            },

            _onSurveySubmitResponse: function (callback, data) {

                logger.debug("received response for survey submit request", "ChatApiController._onSurveySubmitResponse", data);

                this._leaveChatApiFrame(function () {
                    if (!data.error) {
                        callback({result: true});
                    }
                    else {
                        callback({result: false, error: true, serverError: true, message: "LEConnection.survey.submitError", serverMessage: data.error.message});
                    }
                });
            },

            //SURVEY METHODS - END
            //***************************************************************

            //***************************************************************
            // API CALLBACKS

            _onChatApiInit: function (data) {
                logger.debug("CHAT API - init event !!!", "ChatApiController._onChatApiInit", data);

                this._leaveChatApiFrame(function () {
                    if (!data.error) {
                        this._connectionInitialized = true;
                        this._triggerEvent("chatConnection:init", data);
                    }
                    else {
                        this._connectionInitialized = false;
                        this._reportChatApiError(data);
                    }
                }, this);
            },

            _onChatApiLoad: function (data) {
                logger.debug("CHAT API - load event !!!", "ChatApiController._onChatApiLoad", data);

                this._leaveChatApiFrame(function () {
                    this._triggerEvent("chatConnection:load", data);
                }, this);
            },

            _onChatApiState: function (data) {
                logger.debug("CHAT API - state event !!!", "ChatApiController._onChatApiState", data);

                this._leaveChatApiFrame(function () {

                    if (!this._checkForError(data)) {

                        var eventInfo = {initSource: this._chatInitiatedBy, state: data.state, states: this._chatStates};

                        switch (data.state) {
                            case this._chatStates.NOTFOUND:
                            case this._chatStates.ENDED:
                                this._onChatEndSuccess(false, data);
                                break;
                            case this._chatStates.CHATTING:
                                this._handleChattingState(eventInfo);
                                break;
                            case this._chatStates.WAITING:
                                this._setChatInitSource();
                                this._chatEnded = false;
                                this._triggerEvent("chatConnection:chat:waiting", eventInfo);
                                break;
                            case this._chatStates.RESUMING:
                                this._setChatInitSource();
                                this._triggerEvent("chatConnection:chat:resuming", eventInfo);
                                break;
                        }
                        this._triggerEvent("chatConnection:state", data);
                    }
                }, this);
            },

            _handleChattingState: function (eventInfo) {

                // chatIsActive is now only set by the notificationController.
                //this._connectionPanelContextModel.set("chatIsActive", true);
                this._chattingInProgress = true;
                this._chatEnded = false;
                this._setChatInitSource();
                this._triggerEvent("cpChatUI:display:chatFrame");
                this._triggerEvent("chatConnection:chat:chatting", eventInfo);
                this._triggerEvent("chatConnection:chat:sessionInfo", this._getSessionInfo());
            },

            _onChatInfo: function (data) {
                logger.debug("CHAT API - chat info event !!!", "ChatApiController._onChatInfo", data);
            },

            _onChatLines: function (data) {

                logger.debug("CHAT API - chat line event !!!", "ChatApiController._onChatLines", data);

                this._leaveChatApiFrame(function () {

                    if (!this._checkForError(data)) {
                        this._triggerEvent("chatConnection:chat:lines", data.lines);
                    }
                });
            },

            _onAgentTyping: function (data) {

                logger.debug("CHAT API - agent typing event !!!", "ChatApiController._onAgentTyping", data);

                this._leaveChatApiFrame(function () {
                    if (!this._checkForError(data)) {
                        this._triggerEvent("chatConnection:chat:agentTyping", data);
                    }
                });
            },

            _onChatApiError: function (data) {
                logger.debug("CHAT API - ERROR event !!!", "ChatApiController._onChatApiError", data);

                this._leaveChatApiFrame(function () {
                    this._checkForError(data);
                });
            },

            // API CALLBACKS - END
            //***************************************************************

            //***************************************************************
            //REQUESTS RESPONSES HANDLERS

            _onChatRequestAvailabilityResponse: function (data, chatReq) {

                //todo: update the contact availability in the collection

                logger.debug("received availability response for chat request", "ChatApiController._onChatRequestAvailabilityResponse", {data: data, req: chatReq});

                this._leaveChatApiFrame(function () {
                    if (!data.error) {
                        if (data.availability) { //skill is available for chat
                            this._sendApiChatRequest(chatReq);
                        }
                        else { // try the backup skill if present //HERE
                            if(chatReq.backupSkill){
                                chatReq.skill = chatReq.backupSkill;
                                chatReq.backupSkill = ""; //avoids infinite loop
                                this._issueChatRequestForSkill(chatReq);
                            }
                        }
                    }
                    else {
                        this._sendApiChatRequest(chatReq);  //failed to get availability but try to initiate the chat so user is less affected.
                    }
                });
            },

            _onChatRequestResponse: function (data) {
                logger.debug("received response to start-chat request", "ChatApiController._onChatRequestResponse", data);

                this._chatRequestIssuing = false;

                this._leaveChatApiFrame(function () {

                    if (!data.error) {
                        this._triggerEvent("chatConnection:chat:chatting", {initSource: this._chatInitiatedBy, state: this._chatStates.CHATTING, states: this._chatStates});
                    }
                    else {  //failed to request chat - could happen if no availability for example

                        var errorType = CP_CONST.CHAT_ERROR_TYPES.GENERAL;

                        if (data.error.internalCode === CP_CONST.CHAT_API_ERROR_CODES.UNAVAILABLE) {
                            errorType = CP_CONST.CHAT_ERROR_TYPES.UNAVAILABLE; //{"error":{"time":"2014-12-27T23:30:51.837+02:00","reason":"no-available-agents","message":"Availability state is: Away","internalCode":32}}
                        }

                        this._chatChannel.vent.trigger("chatConnection:error", {errorType: errorType});
                        LEConnection.notifier.showError(LE.translator.translate("LEConnection.chat.livePersonChatWidgetContactUnavailable"));
                    }
                });
            },

            _onChatEndSuccess: function (disposed, data) {

                logger.debug("chat ended successfully", "ChatApiController._onChatEndSuccess", data);

                if (!disposed && !this._chatEnded) { //no point in going in if chat was already ended and everything was cleared

                    var wasInProgress = this._chattingInProgress;
                    this._clearChatFlags();  //have to do this here (inside this frame) or it may be called again before the flags are cleared

                    this._leaveChatApiFrame(function () {
                        this._checkChatEndExitSurvey(wasInProgress); //start exit survey if chat was in progress

                        if (wasInProgress) {
                            this._triggerEvent("chatConnection:chat:ended", data);
                        }
                    });
                }
            },

            _onChatEndError: function (disposed, data) {

                logger.error("failed to end chat, got server error", "ChatApiController._onChatEndError", data);
                logger.graph({name:"connection:ChatApiController:_onChatEndError"});

                if (!disposed) {

                    var wasInProgress = this._chattingInProgress;
                    this._clearChatFlags(); //have to do this here (inside this frame) or it may be called again before the flags are cleared

                    this._leaveChatApiFrame(function () {
                        this._checkChatEndExitSurvey(wasInProgress); //start exit survey if chat was in progress
                    });
                }
            },

            _clearChatFlags: function () {
                this._chatRequestIssuing = false;
                this._chattingInProgress = false;
                this._chatInitiatedBy = null;
                this._chatEnded = true;
                 //chatIsActive is now only set by the notificationController.
                //this._connectionPanelContextModel.set("chatIsActive", false);
            },

            // REQUESTS RESPONSES HANDLERS - END
            //***************************************************************

            _checkChatOfflineSurvey: function(skill) {
                var onSurveyResponse = function (srvData) {
                    this._onOfflineSurveyResponse(srvData);
                };
                this._leaveChatApiFrame(function () {
                    if (this._chatAPI) {
                        this._chatAPI.getOfflineSurvey({
                            skill: skill,
                            success: onSurveyResponse,
                            error: onSurveyResponse,
                            context: this
                        });
                    }
                });
            },

            _checkChatEndExitSurvey: function (chatInProgress) {

                var surveyRequest;

                if (chatInProgress) {
                    logger.debug("chat was in progress, retrieving exit survey information", "ChatApiController._checkChatEndExitSurvey");
                    if (this._chatAPI) {
                        surveyRequest = this._chatAPI.getExitSurvey({
                            success: this._onExitSurveyResponse,
                            error: this._onExitSurveyResponse,
                            context: this
                        });
                    }
                }
                else {
                    logger.debug("chat wasnt in progress, not attempting to retrieve exit survey information", "ChatApiController._checkChatEndExitSurvey");
                }

                if (!surveyRequest) {
                    this._triggerEvent("chatConnection:exitSurvey:info", {retrieved: false});
                }
            },

            _createChatApiObject: function (options) {

                var chat;

                try {
                    chat = new lpTag.taglets.ChatOverRestAPI({
                        lpNumber: options.site,
                        domain: options.domain,
                        appKey: options.appKey,
                        sessionUID: options.sessionUID,

                        onLoad: _.bind(this._onChatApiLoad, this),
                        onInit: _.bind(this._onChatApiInit, this),
                        onLine: _.bind(this._onChatLines, this),
                        onInfo: _.bind(this._onChatInfo, this),
                        onState: _.bind(this._onChatApiState, this),
                        onAgentTyping: _.bind(this._onAgentTyping, this),
                        onError: _.bind(this._onChatApiError, this)
//                    onVisitorDisposed: { callback: this.onVisitorDisposed, context: this }
                    });
                }
                catch (ex) {
                    logger.error("failed to create chat api object", "ChatApiController._createChatApiObject", ex);
                    logger.graph({name:"connection:ChatApiController:_createChatApiObject:fail"});
                }

                return chat;
            },

            _checkForError: function (data) {

                var error = data.error;

                if (error && !this._blockErrors) {
                    this._blockErrors = true;
                    this._retryCount++;
                    this._reportChatApiError(data);
                    if(this._retryCount > RETRY_COUNT){
                        this._blockErrors = false;
                        this._endChat();
                    }else{
                        setTimeout(_.bind(function(){
                            this._blockErrors = false;
                        },this), this._retryCount * WAIT_TIME); // we wait retry * wait time so we wait always + 5 seconds more on each error..
                    }
                }else{
                    this._retryCount = 0;
                }

                return !!error;
            },

            _reportChatApiError: function (info) {
                logger.warn("encountered chat api error", "ChatApiController._reportChatApiError", info);
            },

            _endChat: function (disposeVisitor) {

                this._chatInitiatedBy = null;

                disposeVisitor = disposeVisitor || false;

                if (this._getCanEndChat()) {
                    logger.debug("issuing end chat request", "ChatApiController._endChat",this._getCurrentState());

                    var request = this._chatAPI.endChat({
                        disposeVisitor: disposeVisitor,
                        success: _.bind(this._onChatEndSuccess, this, disposeVisitor),
                        error: _.bind(this._onChatEndError, this, disposeVisitor)
                    });

                    if (request.error) {
                        this._onChatEndError(disposeVisitor, request);
                    }
                }
                else {
                    if (!this._getIsChatting()) {
                        this._onChatEndSuccess();
                    }
                }
            },

            _getCurrentState: function () {
                var state;

                if (this._chatAPI) {
                    state = this._chatAPI.getState();
                }

                return state;
            },

            _getCanEndChat: function () {

                var currentState = this._getCurrentState();

                return (currentState && currentState !== this._chatStates.UNINITIALISED &&
                    currentState !== this._chatStates.ENDED &&
                    currentState !== this._chatStates.NOTFOUND);
            },

            _setChatInitSource: function () {
                if (!this._chatInitiatedBy) {  //if not set yet like when resuming that default to source = resume
                    this._chatInitiatedBy = CP_CONST.CHAT_INITIATED_SOURCE.RESUME;
                }
            },

            _leaveChatApiFrame: function (fn, context) {   //used by callback methods for chat api events to leave the chat api execution
                context = context || this;
                setTimeout(_.bind(fn, context), 1);
            },

            _triggerEvent: function () {
                this._chatChannel.vent.trigger.apply(this._chatChannel.vent, arguments);
            },

            _onLogout: function () {
                logger.debug("application log out is taking place", "ChatApiController._onLogout");

                if (this._chattingInProgress || this._getIsChatting()) {
                    logger.debug("chat is still in progress, will end it now", "ChatApiController._onLogout");
                    this._endChat(true);
                }
            }
        });
    });


    LE.lpGetAuthentication = function (callback, msgContactModel) {
        var authenticationAttributes = {
            skillName: msgContactModel.getSkillName(),
            isPSGContact: msgContactModel.isPSGContact()
        };
        var authModel = new AuthenticationModel(authenticationAttributes);

        authModel.fetch({
            success: function (obj) {
                LE.logger.debug('Succesfully loaded token for auth model', 'LE.lpGetAuthentication');
                callback(obj.get("jwt"));
            },
            error: function (model, response) {
                LE.logger.error('Could not fetch JWT.', 'LE.lpGetAuthentication',response);
            }
        });

    };

    return ChatApiController;
});
